const stats = [
  { icon: 'ri-user-follow-line', label: '85%+ Job Placement Rate' },
  { icon: 'ri-tools-line', label: 'Industry-Recognized Certifications' },
  { icon: 'ri-community-line', label: '500+ Graduates Placed' },
  { icon: 'ri-time-line', label: '10+ Years Serving DFW' },
  { icon: 'ri-links-line', label: 'Employer Partnerships' },
  { icon: 'ri-star-line', label: '4.9 Participant Rating' },
];

const TrustBar = () => (
  <section className="bg-charcoal border-y border-white/10 py-5">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-wrap items-center justify-between gap-y-4">
        {stats.map((stat, i) => (
          <div key={i} className="flex items-center gap-2.5 px-3">
            <div className="w-7 h-7 flex items-center justify-center shrink-0">
              <i className={`${stat.icon} text-gold text-base`} />
            </div>
            <span className="font-inter text-[13px] font-medium text-white/70 whitespace-nowrap">
              {stat.label}
            </span>
            {i < stats.length - 1 && (
              <div className="hidden lg:block w-[1px] h-5 bg-white/15 ml-3" />
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBar;
